(() => {
  const known = new Set(["HERO_cream.png", "cream_1.png", "copper-peptide-cream-mens-application.png", "peptide-moisturizer-niacinamide-squalane.png", "copper-peptide-cream-fragrance-free.png", "koppa-capsule-cream-packshot.png", "koppa-cream-step-2-nourish.png", "copper-peptide-moisturizer-neck.png", "copper-peptide-cream-80g-vs-50ml.png", "33b7dc3f-0804-43c1-b275-bfeb711b4eae.png", "cream_with_powder.png", "koppa-ghk-cu-comparison-hand-20260925.png", "cream-microbead-skin-diagram-optimized.webp", "koppa-capsule-cream-man-hands.png", "koppa-cream-in-use-cheek.png", "two_creams.webp", "f804653d-b395-4965-931d-9897dcdda53d.png", "koppa-trio-cream.webp"]);
  const cream = /cream|moisturi[sz]er|microbead/i;
  const excluded = new Set(['moisturizer-photo_15','moisturizer-photo_16','moisturizer-photo_17','moisturizer-photo_01']);
  function matches(img) {
    const id=img.dataset.koppaNativeImage;
    if(id && id.startsWith('moisturizer-')) return !excluded.has(id);
    const sources=[img.currentSrc,img.getAttribute('src'),img.getAttribute('data-src')].filter(Boolean);
    if(sources.some(src=>{try{return known.has(new URL(src,location.href).pathname.split('/').pop())}catch{return false}})) return true;
    if(cream.test(img.alt||'') || sources.some(src=>cream.test(src))) return true;
    const link=img.closest('a[href]');
    return !!link && /\/products\/ghk-cu-(moisturizer|microbead-cream)(?:[/?#]|$)/.test(link.getAttribute('href'));
  }
  // Every computed-style read happens before any write. Reading an image's
  // filter straight after tagging the previous one forced a style recalc per
  // image (PageSpeed 2026-09-30: a 119 ms long task on mobile).
  function applyAll(images) {
    const add=[];
    images.forEach(img=>{
      const wanted=matches(img);
      if(wanted && !img.hasAttribute('data-koppa-cream-lighting')) add.push(img);
      else if(!wanted && img.hasAttribute('data-koppa-cream-lighting')) {
        img.removeAttribute('data-koppa-cream-lighting');img.style.removeProperty('--koppa-cream-base-filter');
      }
    });
    const filters=add.map(img=>getComputedStyle(img).filter);
    add.forEach((img,i)=>{
      img.style.setProperty('--koppa-cream-base-filter',filters[i]==='none'?'brightness(1)':filters[i]);
      img.setAttribute('data-koppa-cream-lighting','subtle');
    });
  }
  function collect(node,into) {if(node.nodeType!==1)return;if(node.matches('img'))into.add(node);node.querySelectorAll('img').forEach(img=>into.add(img));}
  const initial=new Set();collect(document.documentElement,initial);applyAll(initial);
  new MutationObserver(records=>{const found=new Set();records.forEach(r=>{if(r.type==='attributes')found.add(r.target);else r.addedNodes.forEach(node=>collect(node,found));});applyAll(found);}).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset','alt','data-src']});
  document.addEventListener('load',e=>{if(e.target instanceof HTMLImageElement)applyAll([e.target]);},true);
})();
